import { FeatureItemProps } from "../../types";
import Nudge from "../../../../common/components/Nudge";
import { getFullUrl } from "../../../../utils/helper";

const FeatureItem = ({ url, title, nudge }: FeatureItemProps) => {
  return (
    <div className="card flex flex-col justify-center items-center gap-[12px] w-[152px] h-[152px] min-w-[96px] py-[12px] px-[8px] max-md:p-0 max-md:pt-[3px] max-md:h-[80px] max-md:gap-[8px]" >
      <div className="relative" >
        <img
          src={getFullUrl(url)}
          alt={title}
          width={56} // default desktop intrinsic size
          height={56}
          sizes="(max-width: 768px) 24px, 56px"
          className="w-[56px] h-[56px] max-md:w-[24px] max-md:h-[24px]"
        />
        {nudge && <Nudge count={nudge} className="absolute left-[33px] bottom-[36px] max-md:left-[14px] max-md:bottom-[14px]" />}
      </div>
      <div className={`text-[16px] font-normal text-black line-clamp-2 max-md:text-[12px] text-center`}>{title}</div>
    </div>
  );
};

export default FeatureItem;